export const getUuid = () => {
  return 'alert-' + Date.now() + '-' + Math.floor(Math.random() * 1000)
}
